import styled from 'styled-components';
import ButtonGroup from '@mlb/react-patterns/v4/components/ButtonGroup/buttonGroup';
import { StyledButton } from '@mlb/react-patterns/v4/components/Button/button.style';
import Skeleton from '@mlb/react-patterns/v4/components/Skeleton/skeleton';
import GDBREAKPOINTS from '../themes/breakpoints';
import { CardWrapper } from '../Card/Card.style';

const { SM_MIN, SM_MAX } = GDBREAKPOINTS;

export const SummaryWrapper = styled.div`
`;

export const Divider = styled.div`
    border-top: 1px solid var(--gameday-divider-color);
    height: 1px;
    margin: 0 1rem;
    @media (min-width: ${SM_MIN}) and (max-width: ${SM_MAX}) {
        display: none;
    }
`;

export const FiltersWrapper = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    justify-content: left;
    flex-direction: row;
    overflow: hidden;
    flex: 1 1 auto;
    align-items: stretch;
    background: var(--gameday-background-color);
    border-bottom: ${({ $stickyEnabled }) => $stickyEnabled ? '1px solid var(--gameday-divider-color)' : 'none'};
    ${({ $stickyEnabled }) => {
        if ($stickyEnabled) {
            return `
                position: sticky;
                top: 0;
                z-index: 9;
            `;
        }
    }};
`;

export const FilterSkeleton = styled(Skeleton)`
    border-radius: 18px;
    margin-right: 1rem;
`;

export const FiltersInnerWrapper = styled.div`
    padding-left: 1rem;
    padding-right: 1rem;
    overflow: auto;
    box-pack: start;
    justify-content: flex-start;
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-start;
    scroll-snap-type: x mandatory;
    height: 46px;
    padding-top: 1rem;
    box-sizing: content-box;
    overflow-y: hidden;
    overflow-x: hidden;

    @media (pointer: coarse) {
        overflow-x: auto;
    }

    &:hover {
        overflow-x: auto;
    }


`;

export const ButtonGroupOverride = styled(ButtonGroup)`

    ${StyledButton} {
        span {
            white-space: nowrap;
        }

        font-family: var(--gameday-primary-font);
        font-size: 14px;
        padding: 6px 10px;
        border-radius: 18px;
        margin-right: 12px;
        background: var(--gameday-filter-button-bgcolor);
        border: 1px solid var(--gameday-filter-button-border);
        line-height: 16px;
        color: var(--gameday-filter-button-fontcolor);
    
        &[data-selected="true"] {
            background: var(--gameday-filter-button-hover-bgcolor);
            border: 1px solid var(--gameday-filter-button-hover-border);
            color: var(--gameday-filter-button-hover-fontcolor);
        }

        &:last-child {
            margin-right: 0;
        }

        @media (hover: hover){
            &:hover {
                background: var(--gameday-filter-button-hover-bgcolor);
                border: 1px solid var(--gameday-filter-button-hover-border);
                color: var(--gameday-filter-button-hover-fontcolor);
            }
        }

    }
`;

export const SummaryPlayListWrapper = styled.div`
    padding-top: 1rem;
`;

export const SummaryPlayCard = styled(CardWrapper).attrs(({ $isTablet }) => ({
    $displayFlat: !$isTablet
}))`
    margin-top: ${({ $isTablet }) => $isTablet ? '8px' : '0'};
    padding: 0px;
`;
